import React from 'react';

import Button from './Button';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Unhandled render error:', error, errorInfo);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <div className="flex min-h-screen w-full flex-col items-center justify-center gap-6 bg-neutral-100 px-6 text-center">
          <div className="flex flex-col items-center gap-2">
            <h1 className="text-lg font-semibold text-neutral-900">
              A problem occurred
            </h1>
            <p className="text-sm text-neutral-500">
              Something went wrong while displaying this page. Please try again.
            </p>
          </div>
          <div className="flex gap-3">
            <Button
              variant="system"
              onClick={() => {
                window.location.href = '/';
              }}
            >
              Go to home
            </Button>
            <Button variant="primary" onClick={() => window.location.reload()}>
              Refresh
            </Button>
          </div>
        </div>
      );
    }
    return children;
  }
}

export default ErrorBoundary;
